import {
  convertHolidayEvent,
  HolidayEvent,
  HolidayEventResponse,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { UpdateHolidayEventParams } from 'holiday_events/types'
import keys from './shared/keys'

type Variables = UpdateHolidayEventParams

export function useUpdateHolidayEvent() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: updateHolidayEvent,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.all }).catch(() => null)
    },
  })

  async function updateHolidayEvent(
    updateParams: Variables
  ): Promise<HolidayEvent> {
    const response = await server.put<HolidayEventResponse.HolidayEvent>(
      `v2/events/holidays/${updateParams.id}`,
      {
        stores_rto_flags: updateParams.storeRtoFlags.map(storeRtoFlag => ({
          store_id: storeRtoFlag.storeId,
          block_rto: storeRtoFlag.blockRto,
        })),
      }
    )
    return convertHolidayEvent(response)
  }
}
